// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as MapConfig from "../map-mods-tbd-catalyst/utils/MapConfig.bs.js";
import * as Belt_Array from "../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_array from "../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as PolylineMod from "../map-mods-tbd-catalyst/types/PolylineMod.bs.js";
import * as OrderMarkersMapper from "../view-mappers/OrderMarkersMapper.bs.js";
import * as LocationBoundsHelper from "../helper/LocationBoundsHelper.bs.js";
import * as PolylineComponentMod from "../map-mods-tbd-catalyst/views/PolylineComponentMod.bs.js";
import * as GoogleMarkerComponent from "../map-mods-tbd-catalyst/google/views/GoogleMarkerComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

function getBounds(order_detail) {
  var markerLocs = LocationBoundsHelper.getLocationBounds(order_detail);
  var bounds = new (window.google.maps.LatLngBounds)(undefined);
  return Belt_Array.reduce(markerLocs, bounds, (function (accumulator, input) {
                return accumulator.extend(input);
              }));
}

function getBilledPolylineComp(polylineDetails) {
  return React.createElement(PolylineComponentMod.make, {
              config: PolylineMod.make_props(Belt_Option.getWithDefault(polylineDetails, []), undefined, Caml_option.some(MapConfig.primaryPolylineColour), undefined, undefined, undefined, undefined),
              key: "billed-polyline"
            });
}

function getDryrunPolylineComp(polylineDetails, showPolyline) {
  if (polylineDetails !== undefined) {
    return React.createElement(PolylineComponentMod.make, {
                config: PolylineMod.make_props(polylineDetails, showPolyline, Caml_option.some(MapConfig.secondaryPolylineColour), undefined, undefined, undefined, undefined),
                key: "dryrun-polyline"
              });
  } else {
    return null;
  }
}

function getVehicleIcon(vehicleType) {
  switch (vehicleType) {
    case /* TWO_WHEELER */0 :
        return {
                TAG: /* Img */0,
                _0: MapConfig.two_wheeler_icon
              };
    case /* THREE_WHEELER */1 :
        return {
                TAG: /* Img */0,
                _0: MapConfig.three_wheeler_icon
              };
    case /* FOUR_WHEELER */2 :
        return {
                TAG: /* Img */0,
                _0: MapConfig.four_wheeler_icon
              };
    
  }
}

function getMarkerComponent(marker, basePosition, markerAnchor, mapInst, uid, showPopup, togglePopupVisibility) {
  return React.createElement(GoogleMarkerComponent.make, {
              mapInst: mapInst,
              markerData: marker,
              basePosition: basePosition,
              markerAnchor: markerAnchor,
              uid: uid,
              showPopup: showPopup,
              togglePopupVisibility: togglePopupVisibility,
              key: String(uid)
            });
}

function getVehicleMarkerComponent(tracerTimeStamp, $$location, mapInst, popupVisibility, togglePopupVisibility, vehicleType) {
  if (tracerTimeStamp !== undefined && $$location !== undefined) {
    return React.createElement(GoogleMarkerComponent.make, {
                mapInst: mapInst,
                markerData: {
                  location: $$location,
                  icon_data: getVehicleIcon(vehicleType),
                  tooltip: {
                    title: "Vehicle Location",
                    ts: OrderMarkersMapper.getTsString(Caml_option.valFromOption(tracerTimeStamp)),
                    address: undefined
                  }
                },
                basePosition: $$location,
                markerAnchor: {
                  iconAnchor: [
                    12,
                    38
                  ],
                  popupAnchor: [
                    0,
                    -36
                  ]
                },
                zIndex: 2000,
                uid: 0,
                showPopup: popupVisibility,
                togglePopupVisibility: togglePopupVisibility,
                key: "vehicle-marker"
              });
  } else {
    return null;
  }
}

function getMarkers(multiAnchorPoints, singleAnchorPoints, mapInst, popupVisibility, togglePopupVisibility, markerDetails) {
  var i = {
    contents: 0
  };
  return ReasonReactUtils$Catalyst.listToReactArray(List.map((function (markerGroup) {
                    var match = List.length(markerGroup);
                    if (match === 0) {
                      return null;
                    }
                    if (match !== 1) {
                      var marker = List.nth(markerGroup, 0);
                      if (marker !== undefined) {
                        return ReasonReactUtils$Catalyst.listToReactArray({
                                    hd: OrderMarkersMapper.getMultiMarkerHolder(marker.location),
                                    tl: List.mapi((function (index, marker$1) {
                                            if (marker$1 !== undefined) {
                                              i.contents = i.contents + 1 | 0;
                                              return getMarkerComponent(marker$1, marker.location, List.nth(multiAnchorPoints, index), mapInst, i.contents, Caml_array.get(popupVisibility, i.contents), togglePopupVisibility);
                                            } else {
                                              return null;
                                            }
                                          }), markerGroup)
                                  });
                      } else {
                        return null;
                      }
                    }
                    var marker$1 = List.nth(markerGroup, 0);
                    if (marker$1 !== undefined) {
                      return ReasonReactUtils$Catalyst.listToReactArray({
                                  hd: OrderMarkersMapper.getSingleMarkerHolder(marker$1.location),
                                  tl: List.map((function (marker$2) {
                                          if (marker$2 !== undefined) {
                                            i.contents = i.contents + 1 | 0;
                                            return getMarkerComponent(marker$2, marker$1.location, singleAnchorPoints, mapInst, i.contents, Caml_array.get(popupVisibility, i.contents), togglePopupVisibility);
                                          } else {
                                            return null;
                                          }
                                        }), markerGroup)
                                });
                    } else {
                      return null;
                    }
                  }), markerDetails));
}

function getWaypointsMarkersComp(waypointDetails, singleAnchorPoints, mapInst, popupVisibility, togglePopupVisibility) {
  if (waypointDetails === undefined) {
    return null;
  }
  var startUid = popupVisibility.length - waypointDetails.length | 0;
  return $$Array.mapi((function (idx, waypoint) {
                return getMarkerComponent(waypoint, waypoint.location, singleAnchorPoints, mapInst, startUid + idx | 0, Caml_array.get(popupVisibility, startUid + idx | 0), togglePopupVisibility);
              }), waypointDetails);
}

export {
  getBounds ,
  getBilledPolylineComp ,
  getDryrunPolylineComp ,
  getVehicleIcon ,
  getMarkerComponent ,
  getVehicleMarkerComponent ,
  getMarkers ,
  getWaypointsMarkersComp ,
  
}
/* react Not a pure module */
